/** Extrai `message` de corpos JSON típicos do Nest (string ou array de validação). */
export function messageFromUnknownApiPayload(
  data: unknown,
  arrayMode: 'join' | 'first' = 'join'
): string | undefined {
  if (typeof data !== 'object' || data === null) {
    return undefined;
  }
  const m = (data as { message?: unknown }).message;
  if (typeof m === 'string' && m.trim()) {
    return m.trim();
  }
  if (Array.isArray(m)) {
    if (arrayMode === 'first') {
      const first = m[0];
      if (typeof first === 'string' && first.trim()) {
        return first.trim();
      }
      return undefined;
    }
    const joined = m.map(String).join(' ').trim();
    return joined || undefined;
  }
  return undefined;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const fromResponse = messageFromUnknownApiPayload(
    (error as { response?: { data?: unknown } })?.response?.data,
    'first'
  );
  if (fromResponse) {
    return fromResponse;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}

export function getAxiosLikeErrorMessage(error: unknown, fallback: string): string {
  const fromResponse = messageFromUnknownApiPayload(
    (error as { response?: { data?: unknown } })?.response?.data
  );
  return fromResponse || fallback;
}
